var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ssp-sidebar-link",on:{"click":_vm.handleClick}},[_c('div',{staticClass:"icon",style:(_vm.style)}),_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))])])
}
var staticRenderFns = []

export { render, staticRenderFns }